import { useContext } from 'react';
import { ConfigContext } from '../contexts/ConfigContext';

export const useLocales = () => {
  const { locales } = useContext(ConfigContext);
  return { locales: locales?.available || [] };
};
